import { register } from 'async-ops';
import { getDefaultOptions, throwExceptionErrors } from '../../../utils/fetch';
import { callMdaePublicApi } from "../../../call-web-api";

export const CREATE_ESMD_DOCUMENT_DRAFT = 'CREATE_ESMD_DOCUMENT_DRAFT';

export const service = async (data) => {
  const response: any = await callMdaePublicApi({
    type: 'post',
    contentType: 'application/json',
    url: '/api/EsMD/CreateEsMdDocumentDraft',
    isRoutedApiCall: true,
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  })
  throwExceptionErrors(response);

  return response;

};

const mockData = () => {
  return ([])
};

const mock = () => Promise.resolve(mockData());

register(CREATE_ESMD_DOCUMENT_DRAFT, service, mock);
